// The code in this file will load on every page of your site

$w.onReady(function () {
	// Write your code here
});


/**
*	Adds an event handler that runs when an element is displayed
 in the viewable part of the current window.
*	 @param {$w.Event} event
*/